export const reportsBreadcrumbsRoutes = {
  '/reports': 'Reports',
  '/reports/analysis': 'Analysis reports',
  '/reports/lots-awaiting-results': 'Lots awaiting results',
};
